function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "69",
  height: "69",
  viewBox: "0 0 69 69",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M40.62 0a1.65 1.65 0 00-1.128.444L35.29 4.338a1.663 1.663 0 01-2.261 0L28.826.444a1.66 1.66 0 00-2.642.526l-2.392 5.205a1.663 1.663 0 01-2.09.866L16.33 5.05a1.663 1.663 0 00-2.24 1.497l-.218 5.725a1.663 1.663 0 01-1.599 1.599l-5.725.217a1.664 1.664 0 00-1.497 2.24l1.99 5.374a1.663 1.663 0 01-.866 2.089L.969 26.184a1.663 1.663 0 00-.525 2.642l3.894 4.202a1.663 1.663 0 010 2.262L.444 39.492c-.77.83-.503 2.17.525 2.642l5.206 2.393a1.663 1.663 0 01.865 2.089l-1.989 5.373a1.663 1.663 0 001.497 2.24l5.725.218c.87.033 1.566.73 1.599 1.598l.218 5.726a1.663 1.663 0 002.24 1.496l5.373-1.99a1.663 1.663 0 012.089.866l2.392 5.206a1.663 1.663 0 002.642.526l4.203-3.894a1.663 1.663 0 012.261 0l4.202 3.894c.83.769 2.17.502 2.642-.526l2.393-5.206a1.663 1.663 0 012.089-.865l5.373 1.99a1.664 1.664 0 002.24-1.497l.218-5.726c.032-.869.73-1.565 1.598-1.599l5.726-.218a1.663 1.663 0 001.496-2.24l-1.99-5.372a1.663 1.663 0 01.866-2.09l5.206-2.392a1.663 1.663 0 00.526-2.642L63.98 35.29a1.663 1.663 0 010-2.262l3.895-4.202c.769-.83.502-2.17-.526-2.642l-5.206-2.392a1.663 1.663 0 01-.865-2.09l1.989-5.372a1.663 1.663 0 00-1.496-2.24l-5.726-.218a1.663 1.663 0 01-1.599-1.6l-.217-5.724a1.663 1.663 0 00-2.24-1.497l-5.373 1.99a1.663 1.663 0 01-2.09-.866L42.135.969A1.66 1.66 0 0040.62 0z",
  fill: "url(#paint0_linear_1234_159)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.884 25.707l-1.05-1.04H29.871V14.26h-6.657v37.807h6.656V31.257h9.131l2.43 2.405v18.406h6.656V29.869l-4.204-4.162z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1234_159",
  x1: "13.21",
  y1: "56.746",
  x2: "58.978",
  y2: "9.915",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B501B0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#2A07F4"
})))));